<ion-app>
  <ng-container *ngIf="showLoader">
    <app-loader></app-loader>
  </ng-container>
  <ng-container *ngIf="!showLoader">
    <ion-router-outlet></ion-router-outlet>
  </ng-container>
</ion-app>